
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 29 27","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M28.302 16.209H16.363v10.46h5.427c6.868 0 7.203-6.974 6.512-10.46z","fill":"#E345FF"}}),_c('path',{attrs:{"d":"M18.962.332H.414v23.336a3 3 0 003 3h19.043c-3.196 0-3.495-4.599-3.495-7.036V.332z","fill":"#5935DD"}}),_c('path',{attrs:{"d":"M6.197 12.129h4.807m-4.807 2.498h4.807m2.496 2.232a4.432 4.432 0 11-.675-7.197","stroke":"#fff"}})])
          )
        }
      }
    